/**
 * Created by daniel.gonzalez on 6/18/15.
 */

'use strict';

module.exports = {
    NOTIFICATION_TYPE: 'mobileInterstitial',
    ITUNES_LINK: 'https://itunes.apple.com/us/app/1stdibs/id938157117',
    FULLSCREEN_NAME: 'fullscreen',
    MC_APP_BANNER: 'messageCenterAppBanner'
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/mobileAds/mobileAdsConstants.js
// module id = 1193
// module chunks = 64